
export interface BaseEntity {
    id: string
    isDeleted: boolean
    name: string
    description: string
}

export interface BaseLookup extends BaseEntity {
    code: string
}

export interface LinerSpecification {
    id: string
    thickness: number
    backingThickness: number
    wearSurfaceThickness: number
    materialType: string
    materialReference: string
    description: string
    brand: string
    grade: string
}

export enum ProvisionType {
    Commissioned = "Commissioned",
    Decommissioned = "Decommissioned",
    Planned = "Planned",
}

export interface ProvisionLinerLocation extends BaseEntity {
    reference: string
    drawingReference: string
    assetSectionId: string
}

export interface ProvisionLinerRegion extends BaseEntity {
    linerId: string
    reference: string
}

export interface ProvisionLiner extends BaseEntity {
    linerLocation: ProvisionLinerLocation
    materialId: string
}

export interface ProvisionSensor extends BaseEntity {
    reference: string,
    linerReference: string
    macAddress: string
    serialNumber: string
}

export interface ProvisionAssetSection extends BaseEntity {
    linerRegionScale: number
}

export interface ProvisionEventEquipment {
    id: string
    assetId: string
    type: ProvisionType
    liners: ProvisionLiner[]
    sensors: ProvisionSensor[]
    eventDate: Date
    description: string
}

export interface ProvisionEvent {
    id: string
    type: ProvisionType
    eventDate: Date
    description: string
    customer: {
        id: string
        name: string
    }
    site: {
        id: string
        name: string
    }
    asset: {
        id: string
        name: string
    }
    isDeleted: boolean
}

export interface CreateProvisionEvent {
    assetId: string
    description: string
    eventDate: string
    type: ProvisionType
}

export interface ProvisionEquipment {
    equpimentId?: string
    linerLocationReference: string
    sensorLocationReference?: string
    serialNumber?: string
    provisionType: ProvisionType
}

export interface EditProvisionEvent extends CreateProvisionEvent {
    id: string
    assetSectionId: string
    liners?: ProvisionEquipment[]
    sensors?: ProvisionEquipment[]
}

export interface ProvisionEquipmentSensorListItem{
    macAddress: string
    serialNumber: string
}